import React, { useState, useEffect, useContext } from 'react';
import SessionContext from 'SessionContext'

/**
 * the component to show the radius dropdown on location widgets
 */
const RadiusSelector = ({ config, signalRender }) => {
    const session = useContext(SessionContext);
    
    const [radiusOptions, setRadiusOptions] = useState();
    const [defaultRadius, setDefaultRadius] = useState();
    const [radiusDataLoaded, setRadiusDataLoaded] = useState(false);
    const [allLocationOptions, setAllLocationOptions] = useState();
    const [locationTypes, setLocationTypes] = useState([]);
    const [selectedOption, setSelectedOption] = useState('3');
    const [locationName, setLocationName] = useState();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [locations, setLocations] = useState([]);
    const [location_type_ids, setLocation_type_ids] = useState([]);
    const configRef = React.useRef(config);
    
    const handleOptionSelect = (option) => {
      setSelectedOption(option);
    };
  
    useEffect(() => {
      function getAllLocationOptions() {
        // get all location with location_type
        let values = Object.keys(session.chartsStore.charts).filter(function(el) {
          return /^location_type.*?/i.test(el);
        });
      
        // get the full objects
        let fullValues = [];
        values.forEach(function(key) {
          fullValues.push(session.chartsStore.charts[key]); 
        });
      
        return fullValues;
      }
      setAllLocationOptions( getAllLocationOptions() );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
      configRef.current = config;
    }, [config]);
  
    function getRadiusFromName() {
      let findRadius = config.id.split('_');
      let radius = findRadius[findRadius.length - 1];
      if(radius) {
        setDefaultRadius(radius);
        setSelectedOption(radius)
      }
    }
  
    function getNameFromLabel() {
      let findName = config.label.split(':');
      if(findName.length) {
        setLocationName(findName[0].trim());
      }
    }


    function buildSelectedValues(current_config_id, current_config_ds) {
      let selected_locations = locations.filter(
          (l) => l.location_type__name === locationName
      );

      const checkIfSelected = (val) => {
        let is_selected = true;
        let x_filters = Object.entries(session.crossfilterStore.filters) || [];
        if(session.crossfilterStore.audience.id && !x_filters.length) {
            x_filters = Object.entries(session.crossfilterStore.audience.filters)
        } 
        if(x_filters.length) {
          x_filters.forEach(([key, filter]) => {
            is_selected = JSON.stringify(filter).includes(val);
            if (filter && filter.length > 0) {
              is_negated = filter[0].is_negated;
            }
          })
        }
        return is_selected;
      }

      let is_negated = 0;
      let series = `${current_config_ds}.${current_config_id}`;
      let values = [];
      selected_locations.length && selected_locations.forEach((val) => {
        let should_select = checkIfSelected(val.name);
        if(should_select) {
            values.push(val.name);
        }
      });
      session.crossfilterStore.add_filter(current_config_id, series, values, is_negated);
    }

    useEffect(() => {
      if (locations.length) {
        buildSelectedValues(configRef.current.id, configRef.current.ds);
      } else {
        loadLocations();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locations, session.crossfilterStore.mapListData])
  
    useEffect(() => {
      getRadiusFromName();
      getNameFromLabel();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  
    // Use cached location types from crossfilterStore instead of fetching per-component
    useEffect(() => {
      if (session.crossfilterStore.locationTypesData) {
        setLocationTypes(session.crossfilterStore.locationTypesData);
      }
      if( !dataLoaded && allLocationOptions && locationTypes.length && defaultRadius && locationName ) {
        setDataLoaded(true);
      }
      getRadiusFromName();
      getNameFromLabel();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption, session.crossfilterStore.locationTypesData])
  
    // Use cached radius defaults from crossfilterStore instead of fetching per-component
    useEffect(() => {
      const response = session.crossfilterStore.radiusDefaults;
      if (response) {
        let options = [
          {id: "1", label: response.radius_1.toString()},
          {id: "2", label: response.radius_2.toString()},
          {id: "3", label: response.radius_3.toString()},
          {id: "4", label: response.radius_4.toString()},
          {id: "5", label: response.radius_5.toString()},
        ];
        setRadiusOptions(options);
        setRadiusDataLoaded(true);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.crossfilterStore.radiusDefaults])
      
    // Use cached mapList from crossfilterStore instead of fetching per-component
    function loadLocations() {
      if (session.crossfilterStore.mapListData) {
        setLocations(session.crossfilterStore.mapListData);
      }
    }

    /**
     * check if the widget was removed from the checkbox component
     */
    useEffect(() => {
      if(location_type_ids !== session.crossfilterStore.location_type_ids) {
        let makeString = [];
        session.crossfilterStore.location_type_ids.forEach((id) => {
          makeString.push(id.toString());
        })
        setLocation_type_ids(makeString);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.crossfilterStore.filters])
  
    /**
     * This makes the call to add the new widget with the updated radius
     * and it removes the existing widget
     */
    useEffect(() => {
      function updateLocationTypePoints(name, config_id) {
        const current_config = configRef.current;

        const selected_locations = locations.filter(
          (l) => l.location_type__name === name
        );

        let updatedRadiusName = "";
        let findName = config_id.split('_');
        findName.pop();
        updatedRadiusName = findName.join('_') + '_' + selectedOption;

        if(!location_type_ids.length) {
          removeCurrent();
          return null;
        } 
          
        let currentWidgetId = findName.pop();
        if(!location_type_ids.includes(currentWidgetId)) {
          removeCurrent();
          return null;
        }
    
        if (selected_locations.length && updatedRadiusName) {
          session.crossfilterStore.setLoadingData(true);
          session.crossfilterStore.update_location_type_radius(
            configRef.current.id, 
            updatedRadiusName
          );
          
          session.crossfilterStore.add_location_type_icon(selected_locations);
          signalRender();
        }
  
        function removeCurrent() {
          current_config.id && session.crossfilterStore.remove_location_type_filter(current_config.id);
          signalRender();
        }
      }
    
      loadLocations();
      if(locationName) {
          updateLocationTypePoints(locationName, configRef.current.id);  // 👈 use ref here too
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOption])
  
    function getSelectedOptionLabel() {
      let label = "";
      radiusOptions && radiusOptions.forEach((item) => {
        if(item.id === selectedOption) {
          label = item.label;
        }
      });
      return label;
    }
    
    if(radiusDataLoaded && !radiusOptions) {
      console.log("No options found for radius dropdown selector.")
      return null;
    }

    const isLoading = session.crossfilterStore.loading_chart_data;

    const buttonLabel = selectedOption ? (
      <>
        {getSelectedOptionLabel()} mi <i className="bi bi-caret-down-fill" />
      </>
    ) : (
      <>
        Radius <i className="bi bi-caret-down-fill" />
      </>
    );

    return (
      <div className="dropdown">
        <button
          className={`dropdown-button ${isLoading ? "btn-disable" : ""}`}
          disabled={isLoading}
        >
          {buttonLabel}
        </button>

        {!isLoading && (
          <ul className="dropdown-list">
            {radiusOptions?.map(option => (
              <li
                key={option.id}
                onClick={() => handleOptionSelect(option.id)}
              >
                {option.label} <span className="lowercase">miles</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

export default RadiusSelector;
